export {};
//# sourceMappingURL=user.types.js.map